module.exports = __webpack_public_path__ + "static/media/inclusion_opd.002f566a.svg";